export default {
  sent: {
    id: 'sourcing_status_sent',
    defaultMessage: 'Sent to the factory',
  },
  toSend: {
    id: 'sourcing_status_to_send',
    defaultMessage: 'Send to factory',
  },
  received: {
    id: 'sourcing_status_received',
    defaultMessage: 'Received at the factory',
  },
  canceled: {
    id: 'sourcing_status_canceled',
    defaultMessage: 'Canceled order',
  },
  counterProposal: {
    id: 'sourcing_status_counter_proposal',
    defaultMessage: 'Counter-offer',
  },
  new: {
    id: 'sourcing_status_new',
    defaultMessage: 'New order',
  },
  pending: {
    id: 'sourcing_status_pending',
    defaultMessage: 'Processing',
  },
  suspended: {
    id: 'sourcing_status_suspended',
    defaultMessage: 'Put on hold',
  },
  moneyTransfered: {
    id: 'sourcing_status_money_tranfered',
    defaultMessage: 'Transfer order',
  },
  validated: {
    id: 'sourcing_status_validated',
    defaultMessage: 'Validated order',
  },
  paid: {
    id: 'sourcing_status_paid',
    defaultMessage: 'Paid order',
  },
  customerAccountPresent: {
    id: 'sourcing_status_customer_account_present',
    defaultMessage: 'Client account present (iCloud / Gmail)',
  },
  saleVoucherMissing: {
    id: 'sourcing_status_sale_voucher_missing',
    defaultMessage: 'Missing transfer order',
  },
  deviceLocked: {
    id: 'sourcing_status_device_locked',
    defaultMessage: 'Unlock code active',
  },
  productNonEuropean: {
    id: 'sourcing_status_product_non_european',
    defaultMessage: 'Product of non-European origin',
  },
  parcelDamaged: {
    id: 'sourcing_status_parcel_damaged',
    defaultMessage: 'Defective package',
  },
  parcelEmpty: {
    id: 'sourcing_status_parcel_empty',
    defaultMessage: 'Empty package',
  },
  parcelNotReceived: {
    id: 'sourcing_status_parcel_not_received',
    defaultMessage: 'Package not received',
  },
  productBlacklisted: {
    id: 'sourcing_status_product_blacklisted',
    defaultMessage: 'Blacklisted product',
  },
  productGreylisted: {
    id: 'sourcing_status_product_greylisted',
    defaultMessage: 'Greylisted product',
  },
  productRooted: {
    id: 'sourcing_status_product_rooted',
    defaultMessage: 'Rooted product',
  },
  productCounterfeit: {
    id: 'sourcing_status_product_counterfeit',
    defaultMessage: 'Counterfeit',
  },
  idMissing: {
    id: 'sourcing_status_id_missing',
    defaultMessage: 'Missing ID',
  },
  delayExpired: {
    id: 'sourcing_page_delay_expired',
    defaultMessage: 'Delay expired by {time}',
  },
}
